import { render, staticRenderFns } from "./spider-menu-button.vue?vue&type=template&id=97237b28"
import script from "./spider-menu-button.ts?vue&type=script&lang=js&external"
export * from "./spider-menu-button.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports